<template>
    <div class="users-style">

        <ul class="list-group mb-3 " v-if='errormsg'>
            <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{ data[0] }}</li>
        </ul>
        {{ successmsg }}

        <b-form @submit.stop.prevent="onSubmit">
            <!-- Abdullah26 added class class="required-field"  -->
            <b-form-group id="name-group" label="Name" label-for="name" class="required-field">
                <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }"
                    :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="email-group" label="Email" label-for="email">
                <b-form-input id="email" name="email" type="email" :disabled="disableme" v-model="fdata.email"
                    v-validate="{ required: true, min: 3, email: true }" :state="validateState('email')"
                    aria-describedby="email-feedback" data-vv-as="Email"></b-form-input>
                <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="phone-group" label="Phone" class="required-field" label-for="phone">
                <b-input-group prepend="+880">
                    <b-form-input id="phone" name="phone" v-model="fdata.phone"
                        v-validate="{ required: true, min: 10, max: 10 }" :state="validateState('phone')"
                        aria-describedby="phone-feedback" data-vv-as="Phone"></b-form-input>
                    <b-form-invalid-feedback id="phone-feedback">{{ veeErrors.first('phone')
                        }}</b-form-invalid-feedback>
                </b-input-group>
            </b-form-group>
                <!-- Abdullah26 added renamed picture -->
            <div id="pic-group" role="group" class="form-group">
                <label id="pic-group__BV_label_" for="company_logo" class="d-block">Picture</label>
                <div class="bv-no-focus-ring cmpny-logo-uploader">
                    <my-upload field="img" @crop-success="cropSuccess" v-model="showLogoUploader" lang-type="en"
                        :width="400" :height="400" img-format="jpeg"></my-upload>

                    <img :src="logoUrl" :width="200" :height="200" @click="toggleLogoUploader" style="cursor: pointer;">
                    <div @click="toggleLogoUploader" class="cmpny-logo-overlay">Upload</div>
                </div>
            </div>


            <b-form-group id="change_password-group" label-for="change_password">
                <b-form-checkbox id="change_password" v-model="fdata.change_password" name="change_password"
                    value="change_password">
                    Change Password
                </b-form-checkbox>
            </b-form-group>

            <!-- alpha fix- added class="required-field" -->
            <b-form-group id="password-group" label="Password" class="required-field" label-for="password" v-if="fdata.change_password">
                <b-form-input id="password" name="password" type="password" v-model="fdata.password"
                    v-validate="{ required: true, min: 8 }" :state="validateState('password')"
                    aria-describedby="password-feedback" data-vv-as="Password"></b-form-input>
                <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password')
                    }}</b-form-invalid-feedback>
            </b-form-group>

            <!-- alpha fix- added class="required-field" -->
            <b-form-group id="password_confirmation-group" label="Confirm Password" class="required-field" label-for="password_confirmation"
                v-if="fdata.change_password">
                <b-form-input id="password_confirmation" name="password_confirmation" type="password"
                    v-model="fdata.password_confirmation" v-validate="{ required: true, confirmed: fdata.password }"
                    :state="validateState('password_confirmation')" aria-describedby="password_confirmation-feedback"
                    data-vv-as="Confirm Password"></b-form-input>
                <b-form-invalid-feedback id="password_confirmation-feedback">{{ veeErrors.first('password_confirmation')
                    }}</b-form-invalid-feedback>
            </b-form-group>

            <!-- Abdullah26 added row and btn -->
            <div class="row">
                <div class="col-md-6 text-left">
                    <b-button type="submit" variant="primary">Submit</b-button>
                </div>

                <div class="col-md-6 text-right">
                    <b-button variant="primary" href="/company/dashboard">
                        Back To Dashboard
                    </b-button>
                </div>
            </div>



        </b-form>

    </div>
</template>

<script>
import myUpload from 'vue-image-crop-upload';
export default {
    components: {
        'my-upload': myUpload,
    },

        data(){
            return {
                disableme : true,
                successmsg:'',
                errormsg:[],
                fdata: {id:null, email: null, password:null , user_level:null, change_password:false, status:null, assigned_companies : [] },

            logoUrl: this.$api_url + '/images/users/' + 'no-image.jpg',
            logoUploaded: false,
            showLogoUploader: false,
        }
    },
    methods: {

        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        toggleLogoUploader() {
            this.showLogoUploader = !this.showLogoUploader;
        },
        cropSuccess(imgDataUrl, field) {

            this.logoUrl = imgDataUrl;
            this.logoUploaded = true;
        },
        editUser: function (x) {

            axios.get(this.$api_url + '/getusersettings', {
                params: {
                    //id: x
                }
            }).then(function (response) {
                this.fdata = response.data;
                this.fdata.phone = response.data.phone.slice(3, 15);
                this.logoUrl = this.$api_url + '/images/users/' + this.fdata.pic;

            }.bind(this));

        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    console.log(`${key}: ${value}`);
                }

                if (this.logoUploaded)
                    formData.append('form_pic', this.logoUrl);

                axios.post(this.$api_url + '/usersettings', formData, config)
                    .then(function (response) {
                        this.$bvToast.toast("Saved", {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });


                        location.reload();


                    }.bind(this))
                    .catch(function (error) {
                        currentObj.errormsg = error.response.data.errors;
                    });
            });
        }


    },
    created: function () {
        this.editUser();
    }
}
</script>
